export type TourPlacement = "top" | "bottom" | "left" | "right";

export interface TourStep {
  id: string;
  target: string;
  title: string;
  content: string;
  placement: TourPlacement;
}

export const TOUR_STEPS: TourStep[] = [
  {
    id: "table-header",
    target: "[data-tour='table-header']",
    title: "Compare One Edge",
    content:
      "Compare your book’s odds with the estimated fair odds. Positive EV means a price advantage, not a guaranteed win.",
    placement: "bottom",
  },
  {
    id: "filter-bar",
    target: "[data-tour='filter-bar']",
    title: "Find What Fits",
    content:
      "In tools that support your saved books, open the book menu, turn on My books, then choose a saved book. Filter by sport, league, or bet type.",
    placement: "bottom",
  },
  {
    id: "odds-cell",
    target: "[data-tour='odds-cell']",
    title: "Open Your Sportsbook",
    content:
      "Click the odds to open your sportsbook. Check the current price before deciding whether to bet.",
    placement: "left",
  },
  {
    id: "advanced-filters",
    target: "[data-tour='advanced-filters']",
    title: "Power Mode",
    content:
      "Adjust book weights, use presets like 'Sharp Books Only', or build your own. Optional—defaults work great.",
    placement: "bottom",
  },
  {
    id: "sidebar-nav",
    target: "[data-tour='sidebar-nav']",
    title: "More Tools",
    content:
      "Arbitrage compares prices across books. Low Hold helps evaluate bonus rollover. Calculators let you check the math.",
    placement: "right",
  },
  {
    id: "learn-button",
    target: "[data-tour='learn-button']",
    title: "Level Up",
    content:
      "Watch a tutorial for the tool you use, then compare the same numbers on the live board.",
    placement: "bottom",
  },
];

export const MOBILE_TOUR_STEPS: TourStep[] = [
  {
    id: "mobile-ev-badge",
    target: "[data-tour='mobile-ev-badge']",
    title: "Your Edge",
    content:
      "+5% EV means $5 of expected profit per $100 wagered over many comparable bets. Any bet can lose.",
    placement: "bottom",
  },
  {
    id: "mobile-card",
    target: "[data-tour='mobile-card']",
    title: "The Plays",
    content:
      "Tap an opportunity to compare prices across books. Check the current line before deciding whether to bet.",
    placement: "bottom",
  },
  {
    id: "mobile-filter-drawer",
    target: "[data-tour='mobile-filter-drawer']",
    title: "Filter It Down",
    content:
      "Use Filters to narrow the board. In tools that support your saved books, use the book menu to choose a saved book.",
    placement: "bottom",
  },
  {
    id: "mobile-menu",
    target: "[data-tour='mobile-menu']",
    title: "More Tools",
    content:
      "More opens Arbitrage, Low Hold, Calculators, and video tutorials.",
    placement: "top",
  },
];
